import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendMandateAdvice } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const MandateAdvice = (props) => {
  const {
    goToBalanceEnquiry,
    goToNameEnquiry,
    sendType,
    mandateAdvice,
    isLoading,
  } = props;

  const handleMandateAdvice1 = () => {
    const payload = {
      type: "success",
    };
    sendType(payload);
  };

  const handleMandateAdvice2 = () => {
    const payload = {
      type: "duplicate",
    };
    sendType(payload);
  };

  const request = mandateAdvice && mandateAdvice.request;
  const response = mandateAdvice && mandateAdvice.response;

  return (
    <InwardXml
      prev={goToNameEnquiry}
      next={goToBalanceEnquiry}
      title={"Mandate Advice (MA)"}
      request={request}
      response={response}
      optiontitle1={"Send MA of any amount for a specific mandate reference no"}
      optiontitle2={"Resend MA of the same amount"}
      handleCase1={handleMandateAdvice1}
      handleCase2={handleMandateAdvice2}
      isLoading={isLoading}
    />
  );
};

MandateAdvice.propTypes = {
  goToBalanceEnquiry: PropTypes.func,
  goToNameEnquiry: PropTypes.func,
  isLoading: PropTypes.bool,
  mandateAdvice: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendMandateAdviceSuccess: state.inwardInteraction.sendMandateAdviceSuccess,
    mandateAdvice: state.inwardInteraction.sendMandateAdvice,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendMandateAdvice(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MandateAdvice);
